export const SESSION_KEY_APP_STATE = 'linkedappState';
export const CID_RHION = 'rd';
export const CID_RHEINLAND = 'rl';
export const CID_CL = 'cl';